import angular from "angular";

angular
    .module('app')
    .component('organizationClientEmployees', {
        template: require('./organization-client-employees.html'),
        controller: ['$http', '$uibModal', 'notifier', controller],
        bindings: {
            organization: '<',
            client: '<',
            fields: '<',
            selectedFields: '<',
        }
    });

function controller($http, $uibModal, notifier) {

    const $ctrl = this;

    $ctrl.employees = [];

    $ctrl.total = null;

    $ctrl.page = 1;

    $ctrl.perPage = 15;

    $ctrl.search = '';

    $ctrl.$onInit = () => {
        $ctrl.getList();
        $ctrl.setTableFields();
    };

    $ctrl.getList = () => {
        $http
            .get(`/control-panel/organizations/${$ctrl.organization.id}/clients/${$ctrl.client.id}/employees/get-list`, {
                params: {
                    page: $ctrl.page,
                    search: $ctrl.search,
                }
            })
            .then(res => {
                $ctrl.total = res.data.total;
                $ctrl.employees = res.data.data;

                $ctrl.employees.forEach(emp => {
                    emp.fieldValues = {};

                    $ctrl.selectedFields.forEach(field => {
                        if (field.pivot.edit_on_directory) {
                            const fieldValue = emp.field_values.find(v => v.field_id === field.id);

                            if (fieldValue) {
                                emp.fieldValues[field.id] = fieldValue.value;
                            }

                            if (field.pivot.default_value && !emp.fieldValues[field.id]) {
                                emp.fieldValues[field.id] = field.pivot.default_value;
                            }
                        }
                    });
                });
            });
    };

    $ctrl.setTableFields = () => {
        $ctrl.tableFields = $ctrl.selectedFields.filter(v => !! v.pivot.edit_on_directory);
    };

    $ctrl.filter = () => {
        $ctrl.page = 1;
        $ctrl.getList();
    };

    $ctrl.openFieldsControlForm = () => {
        $uibModal.open({
            component: 'employeesFieldsControl',
            resolve: {
                organization() {
                    return $ctrl.organization;
                },
                client() {
                    return $ctrl.client;
                },
                fields() {
                    return $ctrl.fields;
                },
                selectedFields() {
                    return $ctrl.selectedFields;
                }
            },
            size: 'lg',
        }).result.then(fields => {
            $ctrl.selectedFields = fields.map(field => {
                let fieldObj = angular.copy($ctrl.fields.find(v => v.id === field.field_id));

                fieldObj.pivot = {
                    custom_title: field.custom_title,
                    edit_on_directory: field.edit_on_directory,
                    edit_on_booking: field.edit_on_booking,
                    required_on_booking: field.required_on_booking,
                    default_value: field.default_value,
                };

                return fieldObj
            });

            $ctrl.setTableFields();
            $ctrl.getList();
        });
    };

    $ctrl.openForm = (employee) => {
        $uibModal.open({
            component: 'employeeForm',
            resolve: {
                organization() {
                    return $ctrl.organization;
                },
                client() {
                    return $ctrl.client;
                },
                fields() {
                    return $ctrl.selectedFields.filter(v => v.pivot.edit_on_directory);
                },
                employee() {
                    return employee;
                }
            },
            size: 'lg',
        }).result.then(res => {
            $ctrl.getList();
        });
    };

    $ctrl.delEmployee = (employee, ind) => {
        if (confirm('Вы действительно хотите удалить данного сотрудника?')) {
            $http
                .post(`/control-panel/organizations/${$ctrl.organization.id}/clients/${$ctrl.client.id}/employees/${employee.id}`, {
                    _method: 'DELETE'
                })
                .then(res => {
                    $ctrl.employees.splice(ind, 1);
                    notifier.successNotify('Успешно удален');
                })
                .catch(err => {
                    notifier.errorResponseNotify(err);
                })
        }
    }
}



// WEBPACK FOOTER //
// ./resources/assets/modules/components/organization-client-employees/organization-client-employees.js